import { useEffect, useState } from 'react';
import { getUsersByCustomerId } from '../../customerDashboard/api/users.api';

/**
 * Candidates for WhatsApp delivery of scheduled videos. Mirrors the backend rule
 * (active user of the customer, any role, with a phone number); the backend stays the authority.
 */
const useResponsibleRecipients = (customerId) => {
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(Boolean(customerId));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!customerId) {
      setRecipients([]);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    getUsersByCustomerId(customerId)
      .then((users) => {
        if (cancelled) return;
        const eligible = (Array.isArray(users) ? users : []).filter(
          (u) => u.active && u.phoneNumber,
        );
        setRecipients(eligible);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('Error fetching responsible users:', err);
        setRecipients([]);
        setError('No se pudo cargar la lista de usuarios.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [customerId]);

  return { recipients, loading, error };
};

export default useResponsibleRecipients;
